import { safeCardUrl } from './activityPageCards.mjs';

// 当前展示与原玩法分开，未知或已删除目标不猜测关联。
export const gameAsset = value => safeCardUrl(value || '');
export const pointDisplay = (presentation, key) => presentation?.pointDraw?.tiers?.find(row => row.key === key) || {};
// 名称使用当前运营展示，档位关联继续使用原key，不随改名改变奖励凭证。
export function pointTierTitle(presentation, tier, index) {
  const current = pointDisplay(presentation, tier.key).title;
  return (typeof current === 'string' && current.trim()) ||
    (typeof tier.title === 'string' && tier.title.trim()) || `射门档位 ${index + 1}`;
}
export const legacyDisplay = (presentation, key) => presentation?.legacyChallenge?.stages?.find(row => row.key === key) || {};
export function legacyDisplayOrder(stages, presentation) {
  const ranks = new Map((presentation?.legacyChallenge?.stages || []).map((row, index) => [row.key, index]));
  return [...(stages || [])].sort((a, b) => (ranks.get(a.key) ?? Infinity) - (ranks.get(b.key) ?? Infinity));
}
export function pointResultDisplay(state, display) {
  if (!state?.recordId) return {};
  switch (state.outcome) {
    case 'PRIZE': return { hint: display.winHint, imageUrl: gameAsset(display.winImageUrl) };
    case 'DEFAULT': return { hint: display.comfortHint, imageUrl: gameAsset(display.emptyImageUrl) };
    case 'EMPTY': return { hint: display.hasDefaultReward ? display.exhaustedHint : display.emptyHint, imageUrl: gameAsset(display.emptyImageUrl) };
    default: return {};
  }
}
export function legacyActionLabel(state, canDraw, presentation) {
  const p = presentation?.legacyChallenge;
  return state?.finished ? p?.finishedLabel || '本关已完成' : canDraw ? p?.startLabel || '使用1次机会转盘' : p?.unavailableLabel || '使用1次机会转盘';
}
const cityNames = { NEW_YORK: '纽约', TORONTO: '多伦多', MEXICO_CITY: '墨西哥城' };
export function challengeSkin(key, presentation) {
  const value = presentation?.challengeSkins?.find(row => row.key === key)?.skin;
  return cityNames[value] ? value : '';
}
export const challengeCity = (key, presentation) => cityNames[challengeSkin(key, presentation)] || '';
export function gameBackground(value) {
  const url = gameAsset(value);
  return url ? { backgroundImage: `url(${JSON.stringify(url)})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {};
}
